import { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import "react-loading-skeleton/dist/skeleton.css";
import "react-toastify/dist/ReactToastify.css";
import "./charts/ChartjsConfig";
import "./css/style.css";

import { AddDictionaryPage } from "./pages/Dictionaries/AddDictionaryPage";
import { DictionariesPage } from "./pages/Dictionaries/DictionariesPage";

import { routes } from "consts";
import { BlockedPage } from "pages/Blocked/BlockedPage";
import { CategoriesPage } from "pages/Categories/CategoriesPage";
import { CategoryAddPage } from "pages/Categories/CategoryAddPage";
import { CategoryEditPage } from "pages/Categories/CategoryEditPage";
import { CoursePage } from "pages/Course/CoursePage";
import { CourseCreatePage } from "pages/CourseCreate/CourseCreatePage";
import { CourseEditPage } from "pages/CourseCreate/CourseEditPage";
import { CourseFormPage } from "pages/CourseCreate/CourseForm/CourseFormPage";
import { CourseExamsPage } from "pages/CourseExams/CourseExamsPage";
import { CourseFinancesPage } from "pages/CourseFinances/CourseFinancesPage";
import { CourseReconciliationPage } from "pages/CourseFinances/Reconciliation/CourseReconciliationPage";
import { CourseGroupAddPage } from "pages/CourseGroup/CourseGroupAddPage";
import { CourseGroupEditPage } from "pages/CourseGroup/CourseGroupEditPage";
import { CourseGroupsPage } from "pages/CourseGroups/CourseGroupsPage";
import { CourseIntegrationsPage } from "pages/CourseIntegrations/CourseIntegrationsPage";
import { CourseInviteUsersPage } from "pages/CourseInviteUsers/CourseInviteUsersPage";
import { CourseManage } from "pages/CourseManage/CourseManage";
import { CourseResourcesPage } from "pages/CourseResources/CourseResourcesPage";
import { CoursesPage } from "pages/Courses/CoursesPage";
import { CourseUserExamPage } from "pages/CourseUserExam/CourseUserExamPage";
import { DashboardPage } from "pages/Dashboard/DashboardPage";
import { EditDictionaryPage } from "pages/Dictionaries/EditDictionaryPage";
import { DiscountAddPage } from "pages/Discounts/DiscountAddPage";
import { DiscountEditPage } from "pages/Discounts/DiscountEditPage";
import { DiscountsPage } from "pages/Discounts/DiscountsPage";
import { ViolatedBundlesPage } from "pages/Discounts/ViolatedBundlesPage";
import { AddDocumentPage } from "pages/Documents/AddDocumentPage";
import { AddDocumentTypePage } from "pages/Documents/AddDocumentTypePage";
import { DocumentsPage } from "pages/Documents/DocumentsPage";
import { DocumentTypesPage } from "pages/Documents/DocumentTypesPage";
import { EditDocumentPage } from "pages/Documents/EditDocumentPage";
import { EditDocumentTypePage } from "pages/Documents/EditDocumentTypePage";
import { PageDocumentAddPage } from "pages/Documents/PageDocumentAddPage";
import { AddDocumentTemplateV2Page } from "pages/DocumentsV2/AddDocumentTemplateV2Page";
import { DocumentsV2Page } from "pages/DocumentsV2/DocumentsV2Page";
import { EditorErrorBoundary } from "pages/DocumentsV2/EditorErrorBoundary";
import { EmailsPage } from "pages/Emails/EmailsPage";
import { ExamCreatePage } from "pages/Exams/Create/ExamCreatePage";
import { ExamEditPage } from "pages/Exams/Create/ExamEditPage";
import { ExamCreatorPage } from "pages/Exams/ExamCreatorPage";
import { ExamsPage } from "pages/Exams/ExamsPage";
import { FinanceCategoriesPage } from "pages/FinanceCategories/FinanceCategoriesPage";
import { FinanceCategoryAddPage } from "pages/FinanceCategories/FinanceCategoryAddPage";
import { FinanceCategoryEditPage } from "pages/FinanceCategories/FinanceCategoryEditPage";
import { DelayedPaymentsPage } from "pages/Finances/DelayedPaymentsPage";
import { FinancesPage } from "pages/Finances/FinancesPage";
import { InvitedStudentsPage } from "pages/InvitedStudents/InvitedStudentsPage";
import { KSeFAddPage } from "pages/KSeF/KSeFAddPage";
import { KSeFEditPage } from "pages/KSeF/KSeFEditPage";
import { KSeFPage } from "pages/KSeF/KSeFPage";
import { KSeFViewPage } from "pages/KSeF/KSeFViewPage";
import { NotificationsPage } from "pages/Notifications/NotificationsPage";
import { PlaceAddPage } from "pages/Places/PlaceAddPage";
import { PlaceEditPage } from "pages/Places/PlaceEditPage";
import { PlacesPage } from "pages/Places/PlacesPage";
import { PlaceTagEditPage } from "pages/PlaceTags/PlaceEditPage";
import { PlaceTagAddPage } from "pages/PlaceTags/PlaceTagAddPage";
import { PlaceTagsPage } from "pages/PlaceTags/PlaceTagsPage";
import { ReportPage } from "pages/Report/ReportPage";
import { ReportsPage } from "pages/Reports/ReportsPage";
import { SettingsPage } from "pages/Settings/SettingsPage";
import { AddUserPage } from "pages/Students/AddUserPage";
import { EditStudentPage } from "pages/Students/EditStudentPage";
import { StudentPage } from "pages/Students/Profile/StudentPage";
import { StudentsPage } from "pages/Students/StudentsPage";
import { SurveyCreatePage } from "pages/SurveyCreate/SurveyCreatePage";
import { SurveyEditPage } from "pages/Surveys/SurveyEditPage";
import { SurveyPagesPage } from "pages/Surveys/SurveyPagesPage";
import { SurveysPage } from "pages/Surveys/SurveysPage";
import { TasksPage } from "pages/Tasks/TasksPage";
import { TopicGroupAddPage } from "pages/TopicGroups/TopicGroupAddPage";
import { TopicGroupEditPage } from "pages/TopicGroups/TopicGroupEditPage";
import { TopicGroupsPage } from "pages/TopicGroups/TopicGroupsPage";
import { TopicAddPage } from "pages/Topics/TopicAddPage";
import { TopicEditPage } from "pages/Topics/TopicEditPage";
import { TopicsPage } from "pages/Topics/TopicsPage";
import { TrainerGroupAddPage } from "pages/TrainerGroupsPage/TrainerGroupAddPage";
import { TrainerGroupEditPage } from "pages/TrainerGroupsPage/TrainerGroupEditPage";
import { TrainerGroupsPage } from "pages/TrainerGroupsPage/TrainerGroupsPage";
import { TrainerPage } from "pages/Trainers/TrainerPage";
import { TrainersEditPage } from "pages/Trainers/TrainersEditPage";
import { TrainersPage } from "pages/Trainers/TrainersPage";
import { UserSurveysPage } from "pages/UserSurveys/UserSurveysPage";
import { VersionsPage } from "pages/Versions/VersionsPage";
import Header from "partials/Header";
import { Sidebar } from "partials/Sidebar";
import { DeleteResourceContextProvider } from "utils/store";
import { DuplicateResourceContextProvider } from "utils/store/duplicate/DuplicateResourceContext";
import { TrainersCreatePage } from "./pages/Trainers/TrainersCreatePage";
// import { RegistrationsPage } from "pages/Registrations/RegistrationsPage";
import { CourseGroupAttributeAddPage } from "pages/CourseGroupAttributes/CourseGroupAttributeAddPage";
import { CourseGroupAttributeEditPage } from "pages/CourseGroupAttributes/CourseGroupAttributeEditPage";
import { CourseGroupAttributesPage } from "pages/CourseGroupAttributes/CourseGroupAttributesPage";
import { CourseGroupImagesPage } from "pages/CourseGroupImages/CourseGroupImagesPage";
import { LandingPageAddPage } from "pages/Shop/LandingPageAddPage";
import { LandingPageEditPage } from "pages/Shop/LandingPageEditPage";
import { LandingPagesPage } from "pages/Shop/LandingPagesPage";
import { BlogPostAddPage } from "pages/Shop/Blog/BlogPostAddPage";
import { BlogPostEditPage } from "pages/Shop/Blog/BlogPostEditPage";
import { BlogPostsPage } from "pages/Shop/Blog/BlogPostsPage";
import { ShopRedirectsPage } from "pages/Shop/Redirects/ShopRedirectsPage";
import { ContactFormSubmissionsPage } from "pages/Shop/ContactFormSubmissions/ContactFormSubmissionsPage";
import { StaticFilesPage } from "pages/StaticFiles/StaticFilesPage";
import { TrainerLectureConfirmationsPage } from "pages/TrainerLectureConfirmations/TrainerLectureConfirmationsPage";
import { CourseStudentsPageV2 } from "pages/CourseStudents/CourseStudentsPageV2";
import { CourseAttendancePage } from "pages/CourseAttendance/CourseAttendancePage";

// pdfme (and the React 19 copy it ships) is only fetched when this route is opened.
const DocumentTemplateV2EditorPage = lazy(() => import("pages/DocumentsV2/DocumentTemplateV2EditorPage"));

function App() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const htmlTag = document.querySelector("html");
    if (htmlTag) {
      htmlTag.style.scrollBehavior = "auto";
      window.scroll({ top: 0 });
      htmlTag.style.scrollBehavior = "";
    }
  }, [location.pathname]);

  return (
    <DeleteResourceContextProvider>
      <DuplicateResourceContextProvider>
        <div className="flex h-[100dvh] overflow-hidden">
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
            <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <Routes>
              <Route path={routes.DASHBOARD} element={<DashboardPage />} />
              <Route path={routes.TASKS} element={<TasksPage />} />
              <Route path={routes.REPORTS} element={<ReportsPage />} />
              <Route path={routes.REPORT()} element={<ReportPage />} />

              <Route path={`${routes.EMAILS}*`} element={<EmailsPage />} />

              <Route path={routes.DICTIONARIES} element={<DictionariesPage />} />
              <Route path={routes.DICTIONARIES_ADD} element={<AddDictionaryPage />} />
              <Route path={routes.DICTIONARIES_EDIT()} element={<EditDictionaryPage />} />

              <Route path={routes.TRAINERS_GROUPS} element={<TrainerGroupsPage />} />
              <Route path={routes.TRAINERS_GROUPS_ADD} element={<TrainerGroupAddPage />} />
              <Route path={routes.TRAINERS_GROUPS_EDIT()} element={<TrainerGroupEditPage />} />

              <Route path={routes.TRAINERS} element={<TrainersPage />} />
              <Route path={routes.TRAINER()} element={<TrainerPage />} />
              <Route path={routes.TRAINERS_ADD} element={<TrainersCreatePage />} />
              <Route path={routes.TRAINERS_EDIT()} element={<TrainersEditPage />} />

              <Route path={routes.COURSES_CATEGORIES} element={<CategoriesPage />} />
              <Route path={routes.COURSES_CATEGORIES_ADD} element={<CategoryAddPage />} />
              <Route path={routes.COURSES_CATEGORIES_EDIT() + "*"} element={<CategoryEditPage />} />


              <Route path={routes.DOCUMENT_TYPES} element={<DocumentTypesPage />} />
              <Route path={routes.DOCUMENT_TYPES_ADD} element={<AddDocumentTypePage />} />
              <Route path={routes.DOCUMENT_TYPES_EDIT()} element={<EditDocumentTypePage />} />

              <Route path={routes.DOCUMENTS} element={<DocumentsPage />} />
              <Route path={routes.DOCUMENTS_PAGES()} element={<PageDocumentAddPage />} />
              <Route path={routes.DOCUMENTS_ADD} element={<AddDocumentPage />} />
              <Route path={routes.DOCUMENTS_EDIT()} element={<EditDocumentPage />} />

              <Route path={routes.SURVEYS_ADD} element={<SurveyCreatePage />} />
              <Route path={routes.SURVEYS} element={<SurveysPage />} />
              <Route path={routes.SURVEYS_PAGES()} element={<SurveyPagesPage />} />
              <Route path={routes.SURVEYS_EDIT()} element={<SurveyEditPage />} />

              <Route path={routes.EXAMS} element={<ExamsPage />} />
              <Route path={routes.EXAMS_CREATOR()} element={<ExamCreatorPage />} />
              <Route path={routes.EXAMS_EDIT()} element={<ExamEditPage />} />
              <Route path={routes.EXAMS_ADD} element={<ExamCreatePage />} />

              <Route path={routes.STUDENTS} element={<StudentsPage />} />
              <Route path={routes.STUDENTS_INVITED} element={<InvitedStudentsPage />} />
              <Route path={routes.STUDENT()} element={<StudentPage />} />
              <Route path={`${routes.STUDENT_NESTED.COURSES()}*`} element={<StudentPage />} />
              <Route path={`${routes.STUDENT_COURSE()}*`} element={<StudentPage />} />
              <Route path={routes.STUDENT_EDIT()} element={<EditStudentPage />} />
              <Route path={routes.USERS_ADD} element={<AddUserPage />} />
              <Route path={routes.STUDENTS_BLOCKED} element={<BlockedPage />} />

              <Route path={routes.DISCOUNTS} element={<DiscountsPage />} />
              <Route path={routes.DISCOUNTS_ADD} element={<DiscountAddPage />} />
              <Route path={routes.DISCOUNTS_EDIT()} element={<DiscountEditPage />} />
              <Route path={routes.DISCOUNTS_VIOLATED_BUNDLES} element={<ViolatedBundlesPage />} />

              <Route path={routes.FINANCES} element={<FinancesPage />} />
              <Route path={routes.DELAYED_PAYMENTS} element={<DelayedPaymentsPage />} />
              <Route path={routes.COURSE_FINANCES()} element={<CourseFinancesPage />} />
              <Route path={routes.COURSE_FINANCES_CATEGORIES} element={<FinanceCategoriesPage />} />
              <Route path={routes.COURSE_FINANCES_CATEGORIES_ADD} element={<FinanceCategoryAddPage />} />
              <Route path={routes.COURSE_FINANCES_CATEGORIES_EDIT()} element={<FinanceCategoryEditPage />} />

              <Route path={`${routes.COURSE_PAGE.BASE()}*`} element={<CoursePage />} />
              <Route path={routes.COURSES_EDIT()} element={<CourseEditPage />} />

              <Route path={routes.COURSES_ADD} element={<CourseCreatePage />} />
              <Route path={routes.COURSES} element={<CoursesPage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.EXAMS()} element={<CourseExamsPage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.USER_EXAM()} element={<CourseUserExamPage />} />
              <Route path={routes.COURSES_MANAGE()} element={<CourseManage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.STUDENTS()} element={<CourseStudentsPageV2 />} />
              <Route path={routes.COURSES_MANAGE_NESTED.ATTENDANCE()} element={<CourseAttendancePage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.INTEGRATIONS()} element={<CourseIntegrationsPage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.STUDENTS_INVITE()} element={<CourseInviteUsersPage />} />

              <Route path={routes.COURSES_MANAGE_NESTED.FINANCES()} element={<CourseFinancesPage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.RECONCILIATION()} element={<CourseReconciliationPage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.RESOURCES()} element={<CourseResourcesPage />} />
              <Route path={routes.COURSES_MANAGE_NESTED.FORM()} element={<CourseFormPage />} />

              <Route path={routes.COURSE_GROUPS_ATTRIBUTES} element={<CourseGroupAttributesPage />} />
              <Route path={routes.COURSE_GROUPS_ATTRIBUTES_ADD} element={<CourseGroupAttributeAddPage />} />
              <Route path={routes.COURSE_GROUPS_ATTRIBUTES_EDIT()} element={<CourseGroupAttributeEditPage />} />
              <Route path={routes.COURSE_GROUPS_IMAGES} element={<CourseGroupImagesPage />} />

              <Route path={routes.COURSE_GROUPS} element={<CourseGroupsPage />} />
              <Route path={routes.COURSE_GROUPS_ADD} element={<CourseGroupAddPage />} />
              <Route path={routes.COURSE_GROUPS_EDIT() + "*"} element={<CourseGroupEditPage />} />

              <Route path={routes.USER_SURVEYS} element={<UserSurveysPage />} />
              {/* <Route path={routes.REGISTRATIONS} element={<RegistrationsPage />} /> */}

              <Route path={routes.NOTIFICATIONS} element={<NotificationsPage />} />

              <Route path={routes.TOPICS} element={<TopicsPage />} />
              <Route path={routes.TOPICS_ADD} element={<TopicAddPage />} />
              <Route path={routes.TOPICS_EDIT()} element={<TopicEditPage />} />

              <Route path={routes.PLACE_TAGS} element={<PlaceTagsPage />} />
              <Route path={routes.PLACE_TAGS_ADD} element={<PlaceTagAddPage />} />
              <Route path={routes.PLACE_TAGS_EDIT()} element={<PlaceTagEditPage />} />

              <Route path={routes.TOPICS_GROUPS} element={<TopicGroupsPage />} />
              <Route path={routes.TOPICS_GROUPS_ADD} element={<TopicGroupAddPage />} />
              <Route path={routes.TOPICS_GROUPS_EDIT()} element={<TopicGroupEditPage />} />

              <Route path={routes.PLACES} element={<PlacesPage />} />
              <Route path={routes.PLACES_ADD} element={<PlaceAddPage />} />
              <Route path={routes.PLACES_EDIT()} element={<PlaceEditPage />} />
              <Route path={routes.SETTINGS()} element={<SettingsPage />} />

              <Route path={routes.KSEF} element={<KSeFPage />} />
              <Route path={routes.KSEF_ADD} element={<KSeFAddPage />} />
              <Route path={routes.KSEF_EDIT()} element={<KSeFEditPage />} />
              <Route path={routes.KSEF_VIEW()} element={<KSeFViewPage />} />

              <Route path={routes.VERSIONS} element={<VersionsPage />} />

              {/* Shop Landing Pages */}
              <Route path={routes.SHOP} element={<Navigate to={routes.SHOP_LANDING_PAGES} replace />} />
              <Route path={routes.SHOP_LANDING_PAGES} element={<LandingPagesPage />} />
              <Route path={routes.SHOP_LANDING_PAGES_ADD} element={<LandingPageAddPage />} />
              <Route path={routes.SHOP_LANDING_PAGES_EDIT()} element={<LandingPageEditPage />} />
              <Route path={routes.SHOP_BLOG} element={<BlogPostsPage />} />
              <Route path={routes.SHOP_BLOG_ADD} element={<BlogPostAddPage />} />
              <Route path={routes.SHOP_BLOG_EDIT()} element={<BlogPostEditPage />} />
              <Route path={routes.SHOP_REDIRECTS} element={<ShopRedirectsPage />} />
              <Route path={routes.SHOP_CONTACT_FORM_SUBMISSIONS} element={<ContactFormSubmissionsPage />} />

              {/* Static Files */}
              <Route path={routes.STATIC_FILES} element={<StaticFilesPage />} />

              <Route
                path={routes.TRAINER_LECTURE_CONFIRMATIONS}
                element={<TrainerLectureConfirmationsPage />}
              />

              {/* Dokumenty 2.0 */}
              <Route path={routes.DOCUMENTS_V2} element={<DocumentsV2Page />} />
              <Route path={routes.DOCUMENTS_V2_ADD} element={<AddDocumentTemplateV2Page />} />
              <Route
                path={routes.DOCUMENTS_V2_EDITOR()}
                element={
                  <EditorErrorBoundary>
                    <Suspense fallback={<p className="p-10 text-sm text-slate-500">Ładowanie…</p>}>
                      <DocumentTemplateV2EditorPage />
                    </Suspense>
                  </EditorErrorBoundary>
                }
              />
            </Routes>
          </div>
        </div>
      </DuplicateResourceContextProvider>
    </DeleteResourceContextProvider>
  );
}

export default App;
